import { useEffect, useMemo } from 'react';
import { useNavigate } from '../../../../../shared/router/useNavigate';

export interface IStateValidation {
	isValid: boolean;
	redirectUrl: string;
}

export function useStateValidation(validations: IStateValidation[]) {
	const navigate = useNavigate();
	const invalidState = useMemo(
		() => validations.find((validation) => !validation.isValid),
		[validations],
	);

	useEffect(() => {
		if (invalidState) {
			navigate(invalidState.redirectUrl);
		}
	}, [invalidState]);
}
